module.exports = __webpack_public_path__ + "ef8e9e51d676994ff368c486340b1c64.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/rp.png
// module id = 1024
// module chunks = 0